"use client";
import { AuthHeader } from '@/components/auth/Header';
import { LoginForm } from '@/components/login-form';
import { Logo } from '@/components/site-header-nav';

export default function LoginPage() {
  return (
    <div className="min-h-svh">
      <AuthHeader currentPage="login" />
      <div className="flex flex-col items-center px-10 gap-4 md:p-10 w-full max-w-xl m-auto pt-16">
        <h1 className="sr-only">Log in to Wee Amici</h1>
        <Logo width={500}  className="mt-10" />
        <div className="w-full -mt-8">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}
